<template>
  <div :class="['container', unit == 1 ? 'personal' : 'team']">
    <div class="layui-container nopad-container">
      <div class="header">
        <header-view></header-view>
      </div>
      <div class="main">
        <nav-step :processes="processes" :unit="unit" :next="next"></nav-step>
        <!-- <TeamTip v-if="stop" :message="message" :award="award"></TeamTip> -->
        <ChooseSchool v-if="next.label === 'choose_school'" :round="round" :label="next.label"></ChooseSchool>
        <TeamUploadFile v-else-if="next.label === 'uploadFile'" :round="round" :label="next.label"></TeamUploadFile>
        <TeamUploadPPT v-else-if="next.label === 'uploadPPT'" :round="round" :label="next.label"></TeamUploadPPT>
        <TeamUploadAnli v-else-if="next.label === 'uploadAnli'" :round="round" :label="next.label"></TeamUploadAnli>
        <TeamVoteTip v-else-if="next.label === 'vote1'" :round="round" :label="next.label"
          :message="'当前正在进行投票，请使用微信小程序扫描二维码查看'" :cover_src="vote_qrcode"></TeamVoteTip>

        <!-- 关注公众号 -->
        <qrCode v-if="next.label === 'wechataccount'" :label="next.label" :round="round"></qrCode>
        <!-- 个人注册信息 -->
        <PersonalRegister v-else-if="next.label === 'person_registration'" :label="next.label" :round="round"></PersonalRegister>
        <!-- 个人赛缴费 -->
        <PersonalPay v-else-if="next.label === 'person_pay'" :label="next.label" :round="round"></PersonalPay>
        <!-- 个人赛答题 -->
        <PersonalQuestion v-else-if="next.label === 'person_question'" :label="next.label" :round="round"></PersonalQuestion>
        <!-- 案例赛注册信息 -->
        <TeamRegister v-else-if="next.label === 'team_registration'" :round="round" :label="next.label"></TeamRegister>
        <!-- 评审 -->
        <TeamReview v-else-if="next.label === 'review'" :round="round" :label="next.label"></TeamReview>
        <!-- 半决赛 -->
        <TeamUploadEntries v-else-if="next.label === '64'" :round="round" :label="next.label">
        </TeamUploadEntries>
      </div>
    </div>
    <div class="footer">
      <footer-view></footer-view>
    </div>

    <el-dialog
        :visible.sync="loginTip"
        width="360px"
        custom-class="login-tip-dialog"
        center>
        <p>如果手机操作为您带来不便，可以复制以下地址在电脑浏览上打开或通过大赛官网“登录”按钮进行登录及后续操作。</p>
        <p><strong>登录地址：</strong><br /><a href="javascript:;">https://gbc.cncima.com/report/login</a></p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="copyAddress('https://gbc.cncima.com/report/login')" size="small" v-clipboard:copy="'https://gbc.cncima.com/report/login'">复制地址</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import "../../assets/css/personal.css";
import "../../assets/css/team.css";
import qrCode from "../../components/public/qr"
import navStep from "../../components/public/step"
import PersonalRegister from "../../components/personal/register"
import PersonalPay from "../../components/personal/pay"
import PersonalQuestion from "../../components/personal/question"

// import ChooseSchool from "../../components/team/chooseSchool"
import TeamRegister from "../../components/team/register"
// import TeamUploadFile from "../../components/team/uploadFile"
import TeamReview from "../../components/team/review"
import TeamUploadEntries from "../../components/team/uploadEntries"
// import TeamUploadPPT from "../../components/team/uploadPPT"
// import TeamUploadAnli from "../../components/team/uploadAnli"
// import TeamTip from "../../components/team/tip"
// import TeamVoteTip from "../../components/team/votesucc"
// import {
//   getStorageRoundInfo
// } from '../../plugins/helper'
import {
  apiGetProcesses,
  apiGetProcess,
  apiGetRounds
} from '../../plugins/apis'
export default {
  data() {
    return {
      round: null,
      next: [],
      history: [],
      processes: [],
      unit: '',
      message: '',
      stop: false,
      vote_qrcode: require("../../assets/images/team/vote_qrcode.jpg"),
      nowTimestamp: (new Date()).getTime(),
      award: false,
      loginTip: false,
    };
  },
  async mounted() {
    console.log('in index');
    const roundRes = await apiGetRounds()
    if(roundRes.code === 200 && roundRes.data?.length){
      this.round = roundRes.data[0]
    }
    if (!this.round) {
      window.location.href = "/report/form"
    }
    // let nowTime = (new Date()).getTime()
    for (let index in this.round.processes) {
      let img = require(`../../assets/images/${this.unit === 1 ? 'personal' : 'team'}/step${parseInt(index) + 1}.png`)
      this.round.processes[index].step_icon = img

      // let isLimit = this.round.processes[index].start_t <= nowTime
      this.round.processes[index].has_next = this.round.processes[parseInt(index) + 1] === undefined ? false : true
    }
    this.processes = this.round.processes
    this.unit = this.round.unit
    await this.getProcessHistory()
    this.$Bus.$on("reload_NowProcess", async () => {
      this.getProcessHistory()
    })

    // this.hideLoginTip();
    // window.addEventListener('resize', () => {
    //   this.hideLoginTip();
    // })
    if(window.innerWidth>767){
      this.loginTip = false
    }else{
      let one = window.localStorage.getItem('ooone')
      if(!one){
        window.localStorage.setItem('ooone',1)
        this.loginTip = true
      }
    }
  },
  methods: {
    async getNowProcess() {
      let res = await apiGetProcess()
      if (res.code === 200) {
        this.next = res.data
      }
    },
    async getProcessHistory() {
      let res = await apiGetProcesses(this.round.round_id)
      if (res.code === 200) {
        this.history = res.data
      }
      this.getHomePageFlag()
    },
    checkMessage() {

    },
    getHomePageFlag() {
      console.log('history', this.history)
      if (this.history.length == 0) {
        this.next = this.processes[0]
        this.processes[0].isActive = true
        this.$set(this.processes, 0, this.processes[0])
        console.log('process', this.processes)
      } else {
        let hasLabels = []
        for (let item of this.history) {
          hasLabels.push(item.process_label)
        }
        let his_label = this.history[this.history.length - 1].process_label
        let iinaa = 0
        let nowTime = (new Date()).getTime()

        for (let index in this.processes) {
          let iit = this.processes[index]
          if (hasLabels.indexOf(this.processes[index].label) > -1) {
            iit.isActive = true
            this.$set(this.processes, index, iit)
          } else {
            iit.isActive = false
            this.$set(this.processes, index, iit)
          }

          if (this.processes[index].label === his_label) {
            iinaa = index
            index = parseInt(index)
            this.processes[index].isActive = true
            let nxt = this.processes[index + 1]
            if (nxt !== undefined && nxt.start_t <= nowTime) {
              this.next = nxt
            } else {
              this.next = this.processes[iinaa]
            }
          }
        }

        for (let index in this.processes) {
          if (this.processes[index].isActive === false && this.processes[index].start_t <= nowTime && this.processes[index].label !== '64') {
            this.processes[index].isActive = true
            break
          }
        }
        console.log('his', this.history[this.history.length - 1], nowTime, this.next)
        if (nowTime < this.next.start_t && this.history[this.history.length - 1].type === 4 && this.history[this.history.length - 1].bool_value === 1) {
          this.stop = this.award = true
          this.message = '恭喜您，您已晋级！'
        }
        // console.log('iinaa',iinaa)

        if (this.next.start_t > nowTime) {
          this.next = this.processes[iinaa]
        }
        // if (this.next.type === 4 || this.next.type === 3 && this.next.label !== 'vote1') {
        //   this.next = this.processes[iinaa]
        // }
        // if (this.history[this.history.length - 1].bool_value === 2) {
        //   this.next = {}
        //   this.stop = true
        //   this.award = false
        //   this.message = '很遗憾，您未晋级！'
        // }
        console.log('next', this.next)
        
        // console.log('111', this.processes);
        // this.next = this.processes[1]
      }
    },

    // hideLoginTip(){
    //   // console.log(window.innerWidth)
    //   if(window.innerWidth>767){
    //     this.loginTip = false
    //   }
    // },

    copyAddress(text) {
      navigator.clipboard.writeText(text);
      this.$message({
        showClose: true,
        message: '地址已复制到剪贴板！',
        type: 'success'
      });
      this.loginTip = false
    }
  },

  components: {
    navStep,

    qrCode,
    PersonalRegister,
    PersonalPay,
    PersonalQuestion,
    TeamRegister,
    // TeamUploadFile,
    TeamReview,
    TeamUploadEntries,
    // TeamTip,
    // TeamUploadPPT,
    // TeamUploadAnli,
    // TeamVoteTip,
    // ChooseSchool
  },
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - 120px) !important;
  display: flex;
  flex-direction: column;
}
</style>
